import React from 'react';

const CrossIcon: React.FC<
  React.PropsWithChildren<React.SVGProps<SVGSVGElement>>
> = (props) => {
  return (
    <svg
      role="presentation"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 87 87"
      {...props}
    >
      <path
        fill="currentColor"
        d="M62.1 24.6c-1.3-1.3-3.3-1.3-4.6 0L43.3 38.8 29.1 24.6c-1.3-1.3-3.3-1.3-4.6 0-1.3 1.3-1.3 3.3 0 4.6l14.2 14.2-14.2 14.2c-1.3 1.3-1.3 3.3 0 4.6 1.3 1.3 3.3 1.3 4.6 0L43.3 48l14.2 14.2c1.3 1.3 3.3 1.3 4.6 0 1.3-1.3 1.3-3.3 0-4.6L47.9 43.4l14.2-14.2c1.2-1.3 1.2-3.4 0-4.6z"
      />
    </svg>
  );
};

export default CrossIcon;
